import { TextInput } from "@mantine/core";

export const BaseTextInput = TextInput